export default {
  subtotal: 'Subtotal',
  tip: 'Tip',
  discount: 'Discount',
  method_fee: 'Delivery fee',
  service_fee: 'Online processing',
  payment_method_upcharge_fee: {
    title: 'PayPal fee',
    description:
      'Every time a customer pays with PayPal, PayPal charges 6-7% fees. So on 100€, we lose 6-7€. Therefore, we unfortunately have to add a surcharge of 3.5% for using PayPal. 🤯 Please consider using one of the other secure and encrypted payment methods at checkout. We are very grateful for your understanding and support! 🙏',
  },
  tax: 'Taxes',
  total: 'Total',
};
